import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import ViewForm from "./ViewForm";

const ViewPaymentTermTemplate = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Payment Term Template - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <ViewForm />
      </div>
      </div>
    </>
  );
};

export default ViewPaymentTermTemplate;
